import React, { Fragment, useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import {
    FeatureHero,
    FeatureCtaButton,
    FeatureSection,
    FeatureCta
} from '../Common/FeatureContent';
import { useLocale } from '../../localization/LocaleContext';
import { ROUTE_PATHS } from '../../localization/constants';
import './resourcePages.css';

const CATEGORY_ICONS = [
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/>
            <line x1="12" y1="20" x2="12" y2="4"/>
            <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
    ),
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 1 C8.5 4.5 11.5 7.5 16 9 C11.5 10.5 8.5 13.5 8 17 C7.5 13.5 4.5 10.5 0 9 C4.5 7.5 7.5 4.5 8 1 Z"/>
            <path d="M18 13 C18.25 14.5 19.75 16.5 22 17 C19.75 17.5 18.25 19.5 18 21 C17.75 19.5 16.25 17.5 14 17 C16.25 16.5 17.75 14.5 18 13 Z"/>
        </svg>
    ),
    (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    )
];

function BlogMain(){
    const { t, toLocalizedPath, locale } = useLocale();
    const p = (key) => t(`resourcePages.blog.${key}`);

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) {
        return <Loader/>;
    }

    const categories = [1, 2, 3].map((num, idx) => ({
        icon: CATEGORY_ICONS[idx],
        title: p(`category${num}Title`),
        description: p(`category${num}Description`)
    }));

    return(
        <Fragment>
            <PageSEO title={p('metaTitle')} description={p('metaDescription')} path={ROUTE_PATHS.blog} locale={locale} />

            <FeatureHero
                eyebrow={p('eyebrow')}
                title={p('heroTitle')}
                highlight={p('heroHighlight')}
                subtitle={p('heroSubtitle')}
                cta={<FeatureCtaButton to={toLocalizedPath('contact')}>{p('heroCta')}</FeatureCtaButton>}
            />

            <FeatureSection alt title={p('categoriesSectionTitle')} description={p('categoriesSectionDescription')}>
                <div className="rp-card-grid rp-card-grid-3">
                    {categories.map((cat, idx) => (
                        <div className="rp-card" key={idx}>
                            <div className="rp-card-icon">{cat.icon}</div>
                            <h3 className="rp-card-title">{cat.title}</h3>
                            <p className="rp-card-description">{cat.description}</p>
                        </div>
                    ))}
                </div>
            </FeatureSection>

            <FeatureSection>
                <div className="rp-coming-soon">
                    <h3 className="rp-coming-soon-title">{p('comingSoonTitle')}</h3>
                    <p className="rp-coming-soon-description">{p('comingSoonDescription')}</p>
                </div>
            </FeatureSection>

            <FeatureCta
                title={p('ctaTitle')}
                description={p('ctaDescription')}
                ctaTo={toLocalizedPath('contact')}
                ctaLabel={p('ctaButton')}
            />

            <Footer/>
        </Fragment>
    );
}

export default BlogMain;
